export const STC_ADMIN = '/stc-admin'
export const STC_LISTENER = '/stc-listener'
export const STC_STUDY = `${STC_LISTENER}/:course_id/:chapter_id?/:topic_id?/:step_id?`
export const STC_CREATE = `${STC_ADMIN}/build/:course_id/:chapter_id?/:topic_id?/:step_id?`
